import Dropdown from '@/components/atoms/dropdown';
import { bigDesktop, tablet } from '@/constants/screensizes';
import useMediaQuery from '@/hooks/useMediaQuery';
import React, { useEffect, useState, useRef } from 'react';

interface SidebarSection {
  name: string;
  value: string;
}

interface SidebarMobilePDPProps {
  sidebarSections: SidebarSection[];
}

const SidebarMobilePDP = ({ sidebarSections }:SidebarMobilePDPProps) => {
  const [activeSection, setActiveSection] = useState(0);
  const [isBigDesktop] = useMediaQuery(bigDesktop);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isServer,setIsServer]=useState(true)

  useEffect(() => {
    if (sidebarSections.length === 0) return;

  }, [activeSection, sidebarSections]);

  useEffect(() => {
    if (dropdownRef.current) {
      dropdownRef.current.scrollTo(activeSection * 40, 0);
    }
  }, [activeSection]);

  const handleDropdownChange = (value: string) => {
    setActiveSection(parseInt(value));
    const id = sidebarSections[parseInt(value)].value;
    const element =!isServer && document.getElementById(id);
    if (element) {
      const position = element.getBoundingClientRect();
      window.scrollTo({
        top: position.top + window.scrollY - (isBigDesktop ? 80 : 40),
        behavior: 'smooth',
      });
    }
  };

  useEffect(()=>{
    setIsServer(false)
  },[])

  return (
    <>
      <div
        // style={{ marginTop: `${distanceToTop / 16 - 2}rem` }}
        className="relative z-10 w-full lg:grid lg:grid-cols-12"
      >
        <div className="w-full mt-5" ref={dropdownRef}>
          <Dropdown onChange={(value) => handleDropdownChange(value)} >
            <Dropdown.Button className='px-5 !text-16 !leading-6'>{sidebarSections[activeSection]?.name}</Dropdown.Button>
            <Dropdown.Options className='pl-3'>
              {sidebarSections.map((section, index) => {
                return <Dropdown.Option key={index} value={index.toString()}><div className="text-16 py-3 px-2">{section.name}</div></Dropdown.Option>;
              })}
            </Dropdown.Options>
          </Dropdown>
        </div>
      </div>
    </>
  );
};

export default SidebarMobilePDP;
